<template>
  <div class="registration safe-distance-top-header">
    <Header pageTitle="报名信息"></Header>
    <div class="registration_bottm">
      <div class="mycourselist" @click="toDetail">
        <img v-lazy="$global.imgUrl + info.cover" alt="" class="img_left" />
        <div class="cent_right">
          <p>{{ info.title }}</p>
          <div class="remark">
            <span class="address">{{
              info.province
                ? info.province + "-" + info.city
                : info.meetingType === 1
                ? "线上会议"
                : "线下会议"
            }}</span>
            <span class="time">{{ info.beginTime.slice(0, 10) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="module_list"
      v-for="(item, index) in registrationList"
      :key="item.id"
    >
      <div class="top">
        <div class="top_left">
          <img
            v-if="item.headPhoto"
            alt=""
            v-lazy="$global.imgUrl + item.headPhoto"
          />
          <img v-else src="@/assets/mylogin/slices/notStarted.png" alt="" />
        </div>
        <div class="top_left_right">
          <div class="top_left_top">{{ item.name }}</div>
          <div class="top_left_bottm">{{ item.skuName }}</div>
        </div>
        <div class="top_right">
          <van-button
            v-if="item.status === 2"
            style="width: 80px; height: 32px"
            type="info"
            round
            @click="toPay"
            >去支付</van-button
          >
          <div v-if="item.status === 0">待审核</div>
          <div v-if="item.status === 1">已拒绝</div>
          <div v-if="item.status === 3">报名成功</div>
          <div v-if="item.status === 4">已取消</div>
        </div>
      </div>
      <div class="van-cell-box">
        <van-cell-group :border="false">
          <van-cell
            style="font-size: 14px; color: #999999"
            title="价格"
            :value="item.skuPrice ? '￥' + item.skuPrice : ''"
          />
          <van-cell
            style="font-size: 14px; color: #999999"
            title="报名时间"
            :value="item.createTime"
          />
        </van-cell-group>
        <van-cell-group
          v-show="item.show && infoList.length > 0"
          :border="false"
        >
          <div v-for="infoItem in infoList" :key="infoItem.code">
            <!-- 图片，职称，研究方向特殊处理 -->
            <van-cell
              v-if="
                infoItem.code != 'headPhoto' &&
                infoItem.code != 'titleList' &&
                infoItem.code != 'subjectList' &&
                infoItem.code != 'org' &&
                item[infoItem.code]
              "
              style="font-size: 14px; color: #999999"
              :title="infoItem.value"
              :value="item[infoItem.code]"
            />
            <div v-if="infoItem.code == 'headPhoto' && item[infoItem.code]">
              <div
                class="van-cell"
                style="
                  width: 100%;
                  height: 50px;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  font-size: 14px;
                  color: #999999;
                "
              >
                <span>头像</span>
                <img
                  style="width: 45px; height: 45px; border-radius: 50%"
                  :src="$global.imgUrl + item[infoItem.code]"
                  alt=""
                />
              </div>
            </div>
            <!-- 职称和学科领域 -->
            <div v-if="infoItem.code == 'titleList' && item[infoItem.code]">
              <van-cell
                v-for="(title, k) in item[infoItem.code]"
                :key="'title' + k"
                :title="k == 0 ? '职称' : ''"
                :value="
                  title.levelOneName +
                  `${title.levelTwo ? ' - ' + title.levelTwo : ''}`
                "
                style="font-size: 14px; color: #999999"
              ></van-cell>
            </div>
            <div v-if="infoItem.code == 'subjectList' && item[infoItem.code]">
              <van-cell
                v-for="(subject, j) in item[infoItem.code]"
                :key="'subject' + j"
                :title="j == 0 ? '学科领域' : ''"
                :value="subject.levelOneName + ' - ' + subject.levelTwoName"
                style="font-size: 14px; color: #999999"
              ></van-cell>
            </div>
            <!-- <div
              v-if="
                infoItem.code == 'org' &&
                item[infoItem.code] &&
                JSON.parse(item[infoItem.code]).name
              "
            >
              <van-cell
                style="font-size: 14px; color: #999999"
                :title="infoItem.value"
                :value="JSON.parse(item[infoItem.code]).name"
              />
            </div> -->
          </div>
        </van-cell-group>
      </div>
      <div class="type" @click="setState(index)">
        {{ item.show ? "收起" : "展开" }}
        <img v-if="item.show" src="@/assets/mylogin/packup.png" alt="" />
        <img v-else src="@/assets/mylogin/unfold.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
export default {
  components: {
    Header,
  },
  name: "Registration",
  data() {
    return {
      show: true,
      info: {},
      registrationList: [],
      infoList: [],
      createUserId: "",
    };
  },
  created() {
    this.info = JSON.parse(this.$route.query.item);
    this.createUserId = JSON.parse(sessionStorage.getItem("userInfo")).user.id;
    this.getapplication();
    this.meetingOrderSignupsConfig();
  },
  methods: {
    toDetail() {
      window.open(
        this.$global.meetingH5Url +
          `pagesModule/meetingDetails/index?type=8&id=${
            this.info.id || this.info.goodsId
          }${this.info.open ? "&open=" + this.info.open : ""}`,
        "_self"
      );
    },
    toPay() {
      this.$router.push({ path: "/orders", query: { name: "2" } });
    },
    async getapplication() {
      const id = {
        meetingId: this.info.id,
        createUserId: this.createUserId,
      };
      const res = await this.$apis.myServe.selectList(id);
      let arr = res.data;
      this.registrationList = arr.map((item) => ({ ...item, show: false }));
    },
    to() {
      window.history.go(-1);
    },
    handleClick(index) {
      const item = this.list[index];
      if (item.isCollapse) {
        item.collapse = !item.collapse;
      }
    },
    setState(index) {
      this.registrationList[index].show = !this.registrationList[index].show;
    },
    async meetingOrderSignupsConfig() {
      const res = await this.$apis.goodsServe.meetingFormTem(this.info.goodsId);
      this.infoList = res.data;
      this.infoList.forEach((item) => {
        if (item.code == "birthday") {
          // 接口返回配置项为 birthday 出生年份，修改为birthdayYear对应参会人信息中字段，只显示年
          item.code = "birthdayYear";
        }
        if (item.code == "titles") {
          // 对应会议参会人数据中字段
          item.code = "titleList";
        }
        if (item.code == "subjects") {
          // 对应会议参会人数据中字段
          item.code = "subjectList";
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.registration {
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f5;
  .registration_bottm {
    .mycourselist {
      display: flex;
      margin: 0 auto;
      padding: 15px 12px;
      width: 351px;
      background: #fff;
      border-radius: 8px;

      .img_left {
        width: 130px;
        height: 73px;
        border-radius: 6px;
        flex: 1;
      }

      .cent_right {
        margin-left: 10px;
        color: #333333;
        p {
          font-size: 15px;
          font-weight: 500;
          color: #333333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        .remark {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;
          font-size: 12px;
          color: #999999;
          .address {
            width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .module_list {
    margin: 12px auto 0;
    padding: 12px;
    width: 351px;
    background: #fff;
    border-radius: 8px;

    .top {
      margin-bottom: 20px;
      width: 100%;
      height: 45px;

      .top_left {
        float: left;

        img {
          width: 45px;
          height: 45px;
          float: left;
        }
      }

      .top_left_right {
        float: left;
        margin-left: 11px;

        .top_left_top {
          margin-bottom: 5px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }

        .top_left_bottm {
          // margin-left: -11px;
          max-width: 100px;
          padding: 3px 5px;
          border-radius: 3px;
          font-size: 10px;
          line-height: 14px;
          color: #397bf9;
          background: rgba(57, 123, 249, 0.1);
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }

      .top_right {
        float: right;
        margin-right: 23px;
        margin-top: 5px;
      }
    }

    .van-cell-box {
      width: 100%;
      &::v-deep .van-cell-group {
        margin-bottom: 17px;
        border-bottom: 1px solid #eee;
        .van-cell {
          padding-bottom: 17px;
          &::after {
            display: none;
          }
          .van-cell__value {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
        }
      }
    }

    .type {
      width: 15%;
      margin: 0 auto;
      text-align: center;
      margin-top: 13px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-bottom: 13px;

      img {
        width: 9px;
        height: 5px;
        margin-bottom: 3px;
      }
    }
  }
}
::v-deep.van-cell__title {
  flex-grow: 1;
  flex-shrink: 0;
}

::v-deep.van-cell__value {
  flex-grow: 2;
  flex-shrink: 0;
}

::v-deep.van-cell::after {
  border: 0;
}
</style>
